import { Field, FieldProps, Form, Formik, FormikHelpers } from "formik";
import { useTranslation } from "react-i18next";
import { Button, Col, Container, Row } from "reactstrap";
import FormikTextbox from "src/components/Common/UI/Formik/FormikTextbox";
import FormikDropdown from "src/components/Common/UI/Formik/FormkDropdown";
import { useGetAllProvidersList } from "../../Parameters/Others/Providers/api/getAllProvidersList";
import { useGetAllPendingStatusList } from "../../Parameters/Others/PendingStatus/api/getAllPendingStatusList";
import { useGetAllSpeedsList } from "../../Parameters/Lines/Speeds/api/getAllSpeedsList";
import { useGetAllLineTypesList } from "../../Parameters/Lines/LineTypes/api/getAllLineTypesList";
import DatePicker from "react-datepicker";


const DataLineSearchForm = ({ initialValues, onSubmit, onClearForm }: DataLineSearchFormProps) => {
  const { t } = useTranslation();
  const getAllProvidersListQuery = useGetAllProvidersList(); 
  const getAllPendingStatusListQuery = useGetAllPendingStatusList(); 
  const getAllSpeedListQuery = useGetAllSpeedsList();
  const getAllLineTypeListQuery = useGetAllLineTypesList();
  const currentDate = new Date();

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={(values, formikHelpers) => {
        onSubmit(values, formikHelpers);
      }}
    >
      {({ isSubmitting, values, setFieldValue, handleChange, resetForm }) => {
        const handleDeleteDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
          handleChange(e);
          if (e.target.value === "") {
            console.log("clearrrr");
            setFieldValue('removalDateTo', "");
            setFieldValue('removalDateFrom', "");
          }
        };

        return (
        <Form>
          <Container fluid className="p-0">
            <Row>
              <Col xs={6}>
                <FormikTextbox 
                  label={"Περιγραφή Γραμμής"} 
                  fieldName={"descline"}           
                />
              </Col>

              <Col xs={6}>
                <FormikDropdown 
                  label={t("Πάροχος")} 
                  fieldName={"providerID"}
                >
                  <option value="">{t("Επιλέξτε Πάροχο")}</option>
                  {getAllProvidersListQuery.data &&
                    getAllProvidersListQuery.data.map((provider) => (
                      <option key={provider.id} value={provider.id}>
                        {provider.description}
                      </option>
                    ))
                  }
                </FormikDropdown>
              </Col>

              <Col xs={6}>
                <FormikTextbox 
                  label={"Κωδικός SAP"} 
                  fieldName={"sapCode"}           
                />
              </Col>

              <Col xs={6}>
                <FormikTextbox 
                  label={"Αριθμός Κλήσης"} 
                  fieldName={"phoneNumber"}           
                />
              </Col>

              <Col xs={6}>
                <FormikTextbox 
                  label={"ID Number"} 
                  fieldName={"hcNmsNum"}           
                />
              </Col>

              <Col xs={6}>
                <FormikDropdown 
                  label={t("Εκκρεμότητα")} 
                  fieldName={"pendingStatusID"}
                >
                  <option value="">{t("Επιλέξτε Εκκρεμότητα")}</option>
                  {getAllPendingStatusListQuery.data &&
                    getAllPendingStatusListQuery.data.map((pendingStatus) => (
                      <option key={pendingStatus.id} value={pendingStatus.id}>
                        {pendingStatus.description}
                      </option>
                    ))
                  }
                </FormikDropdown>
              </Col>

              <Col xs={6}>
                <FormikDropdown 
                  label={t("Ταχύτητα")} 
                  fieldName={"speedID"}
                >
                  <option value="">{t("Επιλέξτε Ταχύτητα")}</option>
                  {getAllSpeedListQuery.data &&
                    getAllSpeedListQuery.data.map((speed) => (
                      <option key={speed.id} value={speed.id}>
                        {speed.description}
                      </option>
                    ))
                  }
                </FormikDropdown>
              </Col>

              <Col xs={6}>
                <FormikDropdown 
                  label={t("Τύπος Γράμμης")} 
                  fieldName={"lineTypeID"}
                >
                  <option value="">{t("Επιλέξτε Τύπο Γράμμης")}</option>
                  {getAllLineTypeListQuery.data &&
                    getAllLineTypeListQuery.data.map((lineType) => (
                      <option key={lineType.id} value={lineType.id}>
                        {lineType.description}
                      </option>
                    ))
                  }
                </FormikDropdown>
              </Col>
          
              <Col xs={6}>
                <FormikDropdown
                  label="Διαγραμμένες"
                  
                  fieldName="deleted"
                  onChange={handleDeleteDropdownChange}
                  value={values.deleted}
                >
                  <option value="">{t("Όχι")}</option>
                  <option value="true">{t("Ναι")}</option>
                </FormikDropdown>
              </Col>

              {values.deleted === 'true' && (
                <Col xs={6}>
                  <Row>
                    <Col xs={6}>
                      <label className="form-label">
                      {t("Από")}
                      </label>
                      <Field 
                        name="removalDateFrom"
                      >
                        {({ field, form }: FieldProps<Date>) => (
                          <DatePicker
                            id="removalDateFrom"
                            {...field}
                            selected={field.value}
                            onChange={(date) => form.setFieldValue(field.name, date)}
                            value={field.value ? field.value.toLocaleDateString('el-GR').split('/').join('-') : ''}
                            className="form-control"
                            dateFormat="dd-MM-yyyy"
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            maxDate={currentDate}
                          />
                        )}
                      </Field>             
                    </Col>
                    <Col xs={6}>
                      <label className="form-label">
                      {t("Έως")}
                      </label>
                      <Field 
                        name="removalDateTo"
                      >
                        {({ field, form }: FieldProps<Date>) => (
                          <DatePicker
                            id="removalDateTo"
                            {...field}
                            selected={field.value}
                            onChange={(date) => form.setFieldValue(field.name, date)}
                            value={field.value ? field.value.toLocaleDateString('el-GR').split('/').join('-') : ''}
                            className="form-control"
                            dateFormat="dd-MM-yyyy"
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            maxDate={currentDate}
                          />
                        )}
                      </Field>             
                    </Col>
                  </Row>
                </Col>
              )}

              <Col xs={12}>
                <label className="form-label">
                  {t("Σχόλια")}
                </label>
                <Field
                  type="text"
                  name="comments"
                  field="comments"
                  className="form-control"
                  as="textarea"
                />
              </Col>
              
            </Row>
            <Row className="row justify-content-end">
              <Col xs="2" className="m-2 me-0">
                <Button
                  type="button"
                  size="sm"
                  color="warning"
                  disabled={isSubmitting}
                  onClick={() => {
                    onClearForm();
                    resetForm();
                  }}
                >
                  {t("Καθαρισμός")}
                </Button>
              </Col>

              <Col xs="2" className="m-2">
                <Button
                  type="submit"
                  size="sm"
                  color="primary"
                  disabled={isSubmitting}
                >
                  {t("Αναζήτηση")}
                </Button>
              </Col>
            </Row>
          </Container>
        </Form>
      )}}
    </Formik>
  )
}

export default DataLineSearchForm;

type DataLineSearchFormProps = {
  initialValues: IDataLineSearchForm;
  onSubmit: (
    values: IDataLineSearchForm,
    formikHelpers: FormikHelpers<IDataLineSearchForm>
  ) => void;
  onClearForm: () => void;
}